// Global "bank account already in use" confirmation dialog.
//
// Mirrors the store-driven PdfViewer pattern: a single <AccountConflictDialog/>
// is mounted once in App.vue and driven from here, so every bank-account save
// handler and the Payment Task can trigger the same Yes/No popup without
// embedding its own dialog.
//
// `confirm` returns a Promise that resolves true (user tapped "Yes, continue")
// or false (user tapped "No"); the dialog calls `respond` to settle it.
export default {
  namespaced: true,

  state: {
    show: false,
    other_customers: [],
    same_customer: [],
    _resolve: null,
  },

  getters: {
    getAccountConflict: (state) => state,
  },

  mutations: {
    OPEN(state, { other_customers, same_customer, resolve }) {
      state.other_customers = other_customers || [];
      state.same_customer = same_customer || [];
      state._resolve = resolve;
      state.show = true;
    },
    RESOLVE(state, value) {
      const resolve = state._resolve;
      state.show = false;
      state.other_customers = [];
      state.same_customer = [];
      state._resolve = null;
      if (resolve) resolve(value);
    },
  },

  actions: {
    // payload: { other_customers, same_customer } -> Promise<boolean>
    confirm({ commit }, payload) {
      return new Promise((resolve) => {
        commit("OPEN", { ...payload, resolve });
      });
    },
    respond({ commit }, value) {
      commit("RESOLVE", value);
    },
  },
};
